/* eslint-disable import/no-unresolved */
import { Button, Select, SelectOption } from 'appkit-react';
import { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';

import { UPDATE_PROJECT } from 'Apollo/Mutations/DataRecon';
import { GET_USERS } from 'Apollo/Queries';
import './UpdateProjectUsers.scss';

const UpdateProjectUsers = ({
    tenantId, project, refetch, setShowUsersDropdown, setToastMessage,
}) => {
    const [users, setUsers] = useState(project.userIdArr);

    /* apollo query to fetch project users */
    const projectUsers = useQuery(GET_USERS, {
        variables: {
            input: {
                tenantId: parseInt(tenantId, 10),
                getAll: true,
            },
        },
    });

    /* apollo mutation to update project users */
    const [updateProject, { loading: projectUpdateloading }] = useMutation(UPDATE_PROJECT, {
        variables: {
            input: {
                projectId: parseInt(project.projectId, 10),
                projectName: project.projecName,
                projectDesc: project.projectDesc,
                userIdArr: users,
                ownerId: parseInt(project.ownerId, 10),
                status: project.status,
                tenantId: parseInt(tenantId, 10),
            },
        },
    });

    /* callback function called when Save button is clicked */
    const updateUsers = async () => {
        await updateProject().then(() => setToastMessage('Project users list is updated.'));
        refetch();
        setUsers(project.userIdArr);
        setShowUsersDropdown(false);
    };

    return (
        <div>
            <div className="project-users-wraper">
                <span className="users-column">
                    <Select
                        size="default"
                        placeholder="Select"
                        onSelect={e => { setUsers(e); }}
                        value={users}
                        name="users"
                        showSearchOnList
                        multiple
                    >
                        {
                            projectUsers.data && (projectUsers.data.getUsers || []).map(user => <SelectOption key={user.userId} value={user.userId}>{user.fullName}</SelectOption>)
                        }
                    </Select>
                </span>
                <span className="users-btn-column">
                    <Button className="a-btn a-btn-primary" size="md" onClick={updateUsers} isLoading={projectUpdateloading}> SAVE </Button>
                </span>
            </div>
        </div>
    );
};

export default UpdateProjectUsers;
